import { apiGet, apiPost, unwrap } from './apiClient';
import type {
  ResponseDTO,
  AdeKeyGenerationRequest,
  AdeKeyGenerationResponse,
  AdeServerTokenUploadResponse,
  AdeConfigurationDTO,
} from '@/types/api';

const BASE = '/api/v1/ade';

export async function generateKeypair(body: AdeKeyGenerationRequest) {
  const res = await apiPost<ResponseDTO<AdeKeyGenerationResponse>>(
    `${BASE}/generate-keypair`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function uploadServerToken(adeAccountId: string, file: File) {
  const form = new FormData();
  form.append('serverTokenFile', file);
  const res = await apiPost<ResponseDTO<AdeServerTokenUploadResponse>>(
    `${BASE}/${adeAccountId}/upload-server-token`,
    form,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function getConfiguration(accountName: string) {
  const res = await apiGet<ResponseDTO<AdeConfigurationDTO>>(
    `${BASE}/configuration/${encodeURIComponent(accountName)}`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function getAllConfigurations() {
  const res = await apiGet<ResponseDTO<AdeConfigurationDTO[]>>(
    `${BASE}/configurations`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
